import styled from "styled-components";

export const Container = styled.div`
    input{
        padding-right: 30px;
    }
`

export const SButton = styled.button`
    
`

export const ErroInput = styled.button`
    font-size: 0.65rem;
    color: #000;
    background: none;
    border: none;
    padding: 0;
    position: absolute;
    box-shadow: none;
    width: auto;
    right: 3px;
    margin-top: -27px;

    span{
        font-size: 1.2rem;
    }
    &:hover{
        background: inherit;
        color: var(--darkblue);
    }
`